import api from "./api";
 
const toFormData = (data) => {
  const fd = new FormData();
  Object.entries(data).forEach(([k, v]) => fd.append(k, v));
  return fd;
};
 
export const register = (data) =>
  api.post("/auth/register", toFormData(data), {
    headers: { "Content-Type": "multipart/form-data" },
  });
 
export const login = (data) =>
  api.post("/auth/login", toFormData(data), {
    headers: { "Content-Type": "multipart/form-data" },
  });
 
export const verifyEmailOtp = (data) =>
  api.post("/auth/verify-email-otp", toFormData(data), {
    headers: { "Content-Type": "multipart/form-data" },
  });
 
export const verifyMobileOtp = (data) =>
  api.post("/auth/verify-mobile-otp", toFormData(data), {
    headers: { "Content-Type": "multipart/form-data" },
  });
 
export const resendOtp = (data) =>
  api.post("/auth/resend-login-otp", toFormData(data), {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const resendRegisterOtp = (data) =>
  api.post("/auth/resend-otp", toFormData(data), {
    headers: { "Content-Type": "multipart/form-data" },
  });
 
export const verifyLoginOtp = (data) =>
  api.post("/auth/verify-login-otp", toFormData(data), {
    headers: { "Content-Type": "multipart/form-data" },
  });
 
export const logout = () =>
  api.post("/auth/logout");
 
export const getProfile = () =>
  api.get("/auth/profile");
 